import axios from 'axios';

// Separate axios instance (and separate token) from services/api.js — that
// one carries the staff admin login token; this one carries the public
// consumer account token (Google Sign-In from non-staff accounts on the
// same /login page), so the two can never collide or get sent to the
// wrong endpoint. Mirrors mobile/src/services/appApi.js.
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? `${window.location.origin}/api`
  : 'http://localhost:3005/api';

const appApi = axios.create({ baseURL: API_BASE_URL });

appApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('consumerToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default appApi;

export const appSavedLandsService = {
  getSavedLandIds: async () => {
    const response = await appApi.get('/app-saved-lands');
    return response.data.savedLandIds;
  },

  // Mirrors mobile's savedLandsService — lets a consumer (non-staff) account
  // save/unsave from the web map too, so "saved" is the same list on both
  // web and mobile for the same signed-in person, not just a read-only view.
  saveLand: async (landId) => {
    const response = await appApi.post('/app-saved-lands', { land_id: landId });
    return response.data;
  },

  unsaveLand: async (landId) => {
    const response = await appApi.delete(`/app-saved-lands/${landId}`);
    return response.data;
  },
};

export const appSharedLandsService = {
  getSharedLandIds: async () => {
    const response = await appApi.get('/app-shared-lands');
    return response.data.sharedLandIds;
  },
};

export const consumerAuthService = {
  getStoredUser: () => {
    const raw = localStorage.getItem('consumerUser');
    return raw ? JSON.parse(raw) : null;
  },
  isSignedIn: () => !!localStorage.getItem('consumerToken'),
  signOut: () => {
    localStorage.removeItem('consumerToken');
    localStorage.removeItem('consumerUser');
  },
};

export const commentsService = {
  getForLand: async (landId) => {
    const response = await appApi.get('/comments', { params: { land_id: landId } });
    return response.data;
  },
  create: async (landId, text) => {
    const response = await appApi.post('/comments', { land_id: landId, text });
    return response.data;
  },
  remove: async (commentId) => {
    await appApi.delete(`/comments/${commentId}`);
  },
};
